/**
 * Amount products
 */

export default function amountProduct() {

  const amounts = Array.from(document.querySelectorAll('[data-js="amount"]'));

  // When amount buttons exists
  if (amounts.length > 0) {

    // change amount on click
    var trigger = function () {
      amounts.forEach(target => {
        let minus = target.querySelector('.amount__minus');
        let input = target.querySelector('input');
        let plus = target.querySelector('.amount__plus');
        minus.addEventListener('click', function() {
          changeValue('minus', parseInt(input.value), input)
        }, false);
        plus.addEventListener('click', function() {
          changeValue('plus', parseInt(input.value), input)
        }, false);
      });
    };
    trigger();

    let changeValue = function(what, currentVal, input) {
      if(what === 'plus') {
        if (!isNaN(currentVal)) {
          input.value = (currentVal + 1);
        } else {
          input.value = 1;
        }
      } else if(what === 'minus') {
        if (!isNaN(currentVal) && currentVal > 1) {
          input.value = (currentVal - 1);
        } else {
          input.value = 1;
        }
      }
    }
  }
}